import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=39e960f2&scoped=true"
import script from "./repair.vue?vue&type=script&lang=ts"
export * from "./repair.vue?vue&type=script&lang=ts"
import style0 from "./repair.vue?vue&type=style&index=0&id=39e960f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e960f2",
  null
  
)

export default component.exports